export default __webpack_public_path__ + "static/media/IMG-20241210-WA0046.f5899e56.jpg";